export const getDefaultState = () => {
  return {
    preSOJobCount: null,
    preSOJobs: [],
    jobForAssignment: {},
    unitPreSOJobs: [],
    showPreSOJobs: false
  };
};

export default {
  ...getDefaultState()
};
